module["exports"] = [
  "###-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/address/postcode.js
// module id = 984
// module chunks = 0